import { render, staticRenderFns } from "./AssessmentCategory.vue?vue&type=template&id=292e87ff&scoped=true"
import script from "./AssessmentCategory.vue?vue&type=script&lang=js"
export * from "./AssessmentCategory.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCategory.vue?vue&type=style&index=0&id=292e87ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292e87ff",
  null
  
)

export default component.exports